<template>
  <div class="view main">
    <Stage />
    <div class="page">
      <HeroSection />
      <StoneSection />
      <HashtagSection />
      <VideoSection />
      <PodcastSection />
      <ShareSection />
      <FooterSection />
    </div>

    <div class="cursor" :style="{ visibility: !cursorVisibile ? 'hidden' : 'visible' }">
      <div class="cursor-ball-wrapper">
        <div class="cursor-ball"></div>
      </div>
    </div>

    <div class="loader">
      <div class="loader__background"></div>
      <div class="loader__content" :style="{ visibility: !visible ? 'hidden' : 'visible' }">
        <br />
        <br />
        <div class="loader__counter">000</div>
        <!-- <div class="loader__brown">HOLD</div>
        <div class="loader__brown">& PEACE</div> -->
      </div>
    </div>

    <Noise v-if="!isMobile" />
  </div>
</template>

<script>
import Stage from '@/components/Stage.vue';
import HeroSection from '@/components/HeroSection.vue';
import StoneSection from '@/components/StoneSection.vue';
import HashtagSection from '@/components/HashtagSection.vue';
import VideoSection from '@/components/VideoSection.vue';
import PodcastSection from '@/components/PodcastSection.vue';
import ShareSection from '@/components/ShareSection.vue';
import FooterSection from '@/components/FooterSection.vue';
import Noise from '@/components/Noise.vue';
import aion from '@/scripts/aion';
import hades from '@/scripts/hades';
import apollo from '@/scripts/apollo';
import animations from '@/assets/animations';

export default {
  name: 'MainView',

  components: {
    Stage,
    HeroSection,
    StoneSection,
    HashtagSection,
    VideoSection,
    PodcastSection,
    ShareSection,
    FooterSection,
    Noise,
  },

  data() {
    return {
      visible: false,
      cursorVisibile: false,
      engine: null,
      hades: null,
      apollo: null,
    };
  },

  computed: {
    isMobile() {
      return window.innerWidth < 720;
    },
  },

  mounted() {
    const stagePromise = new Promise((resolve) => {
      this.$eventHub.$on('stage-loaded', resolve);
    });
    const fontPromise = new Promise((resolve) => {
      this.$eventHub.$on('font-loaded', resolve);
    });
    Promise.all([stagePromise, fontPromise]).then(() => {
      this.visible = true;
      this.engine = aion;
      this.apollo = apollo.init();
      this.hades = hades.init();
      this.$eventHub.$emit('apollo-init');
      this.engine.start();
      this.hades.ref.pause();

      animations.get('loader')(this.$el).eventCallback('onComplete', () => {
        this.hades.ref.play();
        this.cursorVisibile = true;
      }).play();
    });

    // animations.get('film-glitch')(this.$el).play();
  },
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
}

.cursor {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  pointer-events: none;

  @include mq($and: $is-touch-device) {
    display: none;
  }

  &-ball-wrapper {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 22px;
    height: 22px;
  }

  &-ball {
    width: 22px;
    height: 22px;
    border-radius: 100%;
    background-color: $color-primary;
  }
}

.loader {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;

  &__background {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100vmax;
    height: 100vmax;
    margin-left: -50vmax;
    margin-top: -50vmax;
    background-color: $color-primary;
  }

  &__content {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    padding-top: 50px;
    padding-left: 50px;

    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    font-size: rem(360px);
    font-size: calc(360px * var(--rw));
    line-height: rem(320px);
    line-height: calc(320px * var(--rw));

    @include mq($until: ipadL) {
      font-size: rem(280px);
      line-height: rem(240px);
    }

    @include mq($until: ipadP) {
      font-size: rem(140px);
      line-height: rem(120px);
      padding: 20px;
    }
  }


  &__brown {
    color: $color-dark;
  }
}

.page {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100vw;

  section {
    padding-top: 380px;

    @include mq($until: ipadL) {
      padding-top: 200px;
    }

    @include mq($until: ipadP) {
      padding-top: 150px;
    }

    &:nth-child(1) {
      padding-top: 0px;
    }

    &:nth-child(3) {
      padding-top: 300px;

      @include mq($until: ipadL) {
        padding-top: 200px;
      }
    }
  }

  footer {
    padding-top: 380px;
    padding-bottom: 100px;

    @include mq($until: ipadL) {
      padding-top: 200px;
    }

    @include mq($until: ipadP) {
      padding-top: 100px;
      padding-bottom: 20px;
    }
  }
}
</style>
